import { render, staticRenderFns } from "./Comparator.vue?vue&type=template&id=44873643&scoped=true&"
import script from "./Comparator.vue?vue&type=script&lang=ts&"
export * from "./Comparator.vue?vue&type=script&lang=ts&"
import style0 from "./Comparator.vue?vue&type=style&index=0&id=44873643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44873643",
  null
  
)

export default component.exports